import React, { useState } from 'react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';

export default function App() {
  const [token, setToken] = useState(localStorage.getItem('mcusa_token'));

  const handleLogin = (t) => {
    localStorage.setItem('mcusa_token', t);
    setToken(t);
  };
  const handleLogout = () => {
    localStorage.removeItem('mcusa_token');
    setToken(null);
  };

  return token ? (
    <Dashboard onLogout={handleLogout} />
  ) : (
    <Login onLogin={handleLogin} />
  );
}
